
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export const AdminProtectedRoute: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();
  const location = useLocation();

  console.log("AdminProtectedRoute - Auth Status:", { 
    isAuthenticated, 
    isAdmin, 
    isLoading, 
    pathname: location.pathname 
  });

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#1A1A1A] text-white">
        <div className="animate-spin h-6 w-6 border-2 border-blue-500 rounded-full border-t-transparent mr-2"></div>
        <span>Authentifizierung wird geprüft...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log("AdminProtectedRoute: Nicht authentifiziert, Weiterleitung zu admin-login");
    return <Navigate to="/admin-login" replace state={{ from: location }} />;
  }

  if (!isAdmin) {
    console.log("AdminProtectedRoute: Kein Admin, Weiterleitung zur Hauptseite");
    return <Navigate to="/" replace />;
  }

  console.log("AdminProtectedRoute: Admin bestätigt, Zugang erlaubt");
  return children ? <>{children}</> : <Outlet />;
};
